import { lazy } from 'react';
import { wrapLazyNavigatorScreen } from '../../../../../functions/navigation/utils/wrapNavigatorScreen';
import type { ShareCollectionPageProps } from './components/ShareCollectionPageContentWrapper';

const ShareCollectionPageContentWrapper = lazy(
  () => import('./components/ShareCollectionPageContentWrapper'),
);

export const ShareCollectionPage = wrapLazyNavigatorScreen(
  (props: ShareCollectionPageProps) => {
    return <ShareCollectionPageContentWrapper {...props} />;
  },
  {
    headerShown: false,
  },
);
